<template>
    <div>
        <div style="padding: 10px;">
            <el-card class="box-card" style="width: 50%">
                <div slot="header" class="clearfix">
                    <span>功能明细</span>
                    <el-button style="float:right;" v-loading="saveLoading" type="primary" @click="save">保存</el-button>
                </div>
                <el-form ref="form" :model="record" :rules="formRules" label-width="80px">
                    <el-form-item label="功能名称" prop="name">
                        <el-input style="width: 300px" v-model="record.name"></el-input>
                    </el-form-item>
                    <el-form-item label="平台">
                        <el-col :span="8">
                            <el-select style="width: 200px" class="filter-item" v-model="record.sys">
                                <el-option label="运营管理平台" value="PT1">
                                </el-option>
                                <!-- <el-option label="线索聚合平台" value="PT2">
                                </el-option> -->
                            </el-select>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="路径" prop="path">
                        <el-input style="width: 300px" v-model="record.path"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="排序">
                        <el-input-number style="width: 120px" v-model="record.sort" :min="1" :max="100"></el-input-number>
                    </el-form-item> -->
                    <el-form-item label="状态">
                        <el-col :span="8">
                            <el-select style="width: 200px" class="filter-item" v-model="record.status">
                                <el-option label="正常" :value="0">
                                </el-option>
                                <el-option label="冻结" :value="-1">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                </el-form>
            </el-card>

            <el-card class="box-card" style="margin-top:20px;width: 50%">
                <div slot="header" class="clearfix">
                    <span>子功能</span>
                    <el-button style="float: right;" type="primary" @click="showAddDialog">添加</el-button>
                </div>

                <el-table :data="items" border fit highlight-current-row style="width: 100%">
                    <el-table-column align="left" label="功能名称">
                        <template slot-scope="scope">
                            <span>{{scope.row.name}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="left" label="功能标识">
                        <template slot-scope="scope">
                            <span>{{scope.row.identify}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button type="primary" circle size="mini" icon="el-icon-edit" @click="showEditDialog(scope.row)"></el-button>
                            <el-button type="warning" circle size="mini" icon="el-icon-delete" @click="deleteFunc(scope.row.id)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

        <el-dialog title="添加子功能" :visible.sync="newDialogVisible" width="30%">
            <el-form ref="newForm" :model="newForm" :rules="newFormRules" label-position="right" label-width="120px">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 200px" v-model="newForm.name"></el-input>
                </el-form-item>
                <el-form-item label="标识" prop="identify">
                    <el-input style="width: 200px" v-model="newForm.identify"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button @click="newDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addFunc">确定</el-button>
        </span>
        </el-dialog>

        <el-dialog title="编辑子功能" :visible.sync="editDialogVisible" width="30%">
            <el-form ref="editForm" :model="updateForm" :rules="newFormRules" label-position="right" label-width="120px">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 200px" v-model="updateForm.name"></el-input>
                </el-form-item>
                <el-form-item label="标识" prop="identify">
                    <el-input style="width: 200px" v-model="updateForm.identify"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="updateSub">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Sticky from "@/components/Sticky"; // 粘性header组件

export default {
    name: 'SystemFunctionsEdit',
    components: {
        Sticky
    },
    data() {
        return {
            id: "",
            record: {},
            items: [],

            saveLoading: false,
            newDialogVisible: false,
            newForm: {
                name: "",
                identify: "",
            },

            editDialogVisible: false,
            updateForm: {
                id: "",
                name: "",
                identify: "",
            },

            formRules: {
                name: [{
                    required: true,
                    message: '请输入功能名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
                path: [{
                    required: true,
                    message: '请输入路径',
                    trigger: 'blur'
                }]
            },
            newFormRules: {
                name: [{
                    required: true,
                    message: '请输入子功能名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
                identify: [{
                    required: true,
                    message: '请输入子功能标识',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
            }
        }
    },
    activated() {
        this.id = parseInt(this.$route.params.id)
        this.retrieveFunction()
    },
    methods: {
        retrieveFunction() {
            var parent = this;
            this.$httpAuth
                .post("/v1/backendFunctionRpc/get", {
                    id: this.id,
                })
                .then(function (response) {
                    parent.record = response.data.data
                    parent.items = parent.record.subs
                })
        },
        showAddDialog() {
            this.newForm = {
                name: "",
                identify: "",
            }
            this.newDialogVisible = true;
            if (this.$refs['newForm']) {
                this.$refs['newForm'].resetFields();
            }
        },
        addFunc() {
            // this.items.push(this.newForm)
            // this.newDialogVisible = false
            this.$refs['newForm'].validate((valid) => {
                if (valid) {
                    var parent = this;
                    this.$httpAuth
                        .post("/v1/backendFunctionRpc/subAdd", {
                            sys: this.record.sys,
                            name: this.newForm.name,
                            identify: this.newForm.identify,
                            parentId: this.id,
                        })
                        .then(function (response) {
                            parent.items = response.data.data
                            parent.newDialogVisible = false
                        })
                }
            });

        },
        deleteFunc(id) {
            var parent = this;

            this.$confirm('是否删除该子功能?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$httpAuth
                    .post("/v1/backendFunctionRpc/subDelete", {
                        id: id,
                        parentId: parent.id,
                    })
                    .then(function (response) {
                        parent.items = response.data.data
                    })
            })

        },
        save() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.saveLoading = true;
                    var parent = this;
                    this.$httpAuth
                        .post("/v1/backendFunctionRpc/update", {
                            id: this.id,
                            sys: this.record.sys,
                            name: this.record.name,
                            path: this.record.path,
                            sort: this.record.sort,
                            items: JSON.stringify(this.items),
                            status: this.record.status,
                        })
                        .then(function (response) {
                            parent.saveLoading = false;
                            parent.$alert("保存成功", "功能编辑", {
                                confirmButtonText: "确定",
                                callback: action => {
                                    // parent.$store.dispatch("delCurrentView");
                                    // parent.$router.push("/system/role/functions/list");
                                }
                            });
                        })
                        .catch(() => {
                            parent.saveLoading = false;
                        });
                }
            });
        },

        showEditDialog(row) {
            this.updateForm = {
                id: row.id,
                name: row.name,
                identify: row.identify,
            }
            this.editDialogVisible = true;
            if (this.$refs['editForm']) {
                this.$refs['editForm'].resetFields();
            }
        },
        updateSub() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    var parent = this;
                    this.$httpAuth
                        .post("/v1/backendFunctionRpc/subUpdate", {
                            id: this.updateForm.id,
                            name: this.updateForm.name,
                            identify: this.updateForm.identify,
                            parentId: this.id,
                        })
                        .then(function (response) {
                            parent.items = response.data.data
                            parent.editDialogVisible = false
                        })
                }
            });

        },
    }
}
</script>
